export default {
  header: {
    login: 'Log In',
    signup: 'Get Started',
  },
  hero: {
    reviews: '4,200+ 5-star reviews',
    title: 'Never Lose a Receipt Again',
    subtitle: 'Millions of freelancers and small business owners trust Neat to track receipts, manage expenses, and stay tax-ready — all year long.',
    ctaPrimary: 'Try Neat For Free',
    ctaSecondary: 'See How It Works',
    price: 'Get your expenses under control for just $200 per year.',
  },
  marquee: {
    title: 'Mentioned by',
  },
  howItWorks: {
    label: 'HOW NEAT WORKS',
    slides: [
      {
        title: 'Snap It. Forward It. Done.',
        description: 'A receipt lands the moment it happens. Snap a photo, forward an email, or drop in a file — Neat catches it and files it before you have time to lose it.',
        bullets: [
          'Capture receipts on your phone in seconds',
          'Save time searching your inbox for old receipts',
          'Drag-and-Drop files makes uploads easy',
          "Find anything you've saved in seconds, whenever you need it",
        ],
        cta: 'Scan My Receipts',
        image: '/home2/mobile-capture-highlight.png',
      },
      {
        title: 'Tax-Ready Every Day, Not Just in April',
        description: 'Every receipt is automatically matched to the right tax category the moment it\'s captured to meet IRS and CRA requirements. When tax season comes, there\'s nothing to reconstruct — just a report ready for you or your accountant.',
        bullets: [
          'Auto-matched to tax categories',
          'One-click reports for your accountant',
          'Deduction tracking, built in year-round',
          'No shoeboxes, no scrambling',
        ],
        cta: 'Get Tax Ready',
        image: '/home2/extracted-data-highlight.png',
      },
      {
        title: 'Know Exactly Where Your Money Went',
        description: 'Subscriptions, travel, supplies, meals — Neat pulls it all together so you always know what you spent and why.',
        bullets: [
          'Always know where your money is going',
          'Check in anytime and see exactly where you stand',
          'Easily search any expense in seconds',
        ],
        cta: 'Organize My Expenses',
        image: '/home2/business-insights-highlight.png',
      },
    ],
  },
  testimonials: {
    title: 'Thousands of 5-Star Reviews From Small Business Owners',
    subtitle: 'Real feedback from freelancers and small business owners who use Neat every day.',
    reviewCount: '5 (5,833 reviews)',
    items: [
      {
        name: 'Steve B.',
        role: 'Independant Consultant',
        quote: 'I\'ve used Neat since 2008, initially for my independent consulting business, and now personally. It\'s a superb app for receipts, yes I could use Google or Microsoft apps and cloud drives, but it would take too much time. I love Neat and recommend it.',
        logo: '/home2/testimonials/Steve_Bauer.webp',
      },
      {
        name: 'Vic S.',
        role: '2D House Inc.',
        quote: 'I have been a Neat customer for over 10 years. I use it both for my professional as well as personal finance planning and control. Neat offers an extremely efficient method of inputting receipts, invoices, contracts, etc, greatly reducing the effort and timing for data input. Report creation is a very strong component of Neat',
        logo: '/home2/testimonials/Vic_Sprenger.webp',
      },
      {
        name: 'Deborah W.',
        role: 'Customer',
        quote: 'Been using Neat for over 15 years. So wonderful. I load and then send to me CPA. Easy!!',
        logo: '/home2/testimonials/Deborah W.webp',
      },
      {
        name: 'Bud J.',
        role: 'Customer',
        quote: 'GREAT FOR TAXES!',
        logo: '/home2/testimonials/Bud_Joyner.webp',
      },
      {
        name: 'Ed G.',
        role: 'Customer',
        quote: 'This is a simple-to-use but comprehensive bank, credit card, investment account, and receipt electronic documentation application that allows me to keep track of all my accounts and expenditures effortlessly.',
        logo: '/home2/testimonials/Ed_Goldner.webp',
      },
    ],
  },
  whyNeat: {
    label: 'WHY NEAT?',
    title: 'The smartest place to start',
    description: 'Neat is built for freelancers and small businesses with 0–5 employees who want clarity without complexity. While most tools are built for corporate finance teams, we focus on doing a few things extremely well: capturing receipts, organizing expenses, and keeping you tax-ready all year.\n\nA business of one deserves a system built for one.',
    features: [
      {
        icon: '/home2/users-icon.svg',
        title: '2M+ users',
        description: '2M+ freelancers and small business owners trust Neat to stay organized and tax-ready, year after year.',
        blob: '/home2/purple-blob.svg',
      },
      {
        icon: '/home2/20years-icon.svg',
        title: 'Built for businesses like yours',
        description: 'We work with small business owners, not finance teams. No financial expertise necessary. Neat is a simple platform with simple pricing, designed to make your life easier.',
        blob: '/home2/green-blob.svg',
      },
      {
        icon: '/home2/encryption-icon.svg',
        title: 'Bank-level encryption',
        description: 'Your financial data is protected with advanced security standards and secure cloud storage.',
        blob: '/home2/purple-blob.svg',
      },
      {
        icon: '/home2/media-icon.svg',
        title: 'Peace of Mind, All Year Long',
        description: 'From tax season to day-to-day operations, you have enough to worry about. Neat delivers the peace of mind small business owners need.',
        blob: '/home2/green-blob.svg',
      },
    ],
  },
  bottomCta: {
    title: 'Ready to get Neat?',
    subtitle: 'Join millions of freelancers and small businesses who stopped chasing receipts and started feeling in control.',
    cta: 'Start My Free Trial',
    cancelAnytime: 'Cancel anytime',
    moneyBack: '30-day money-back guarantee',
  },
  footer: {
    copyright: '© 2026 Neat. All rights reserved.',
  },
}
